import axios from "axios";
import { toast } from 'react-toastify'

import Urls from "../../Utilities/General/Urls";
import { getToken } from "../../Utilities/Auth/AuthPermissions";
import { networkError, error, serverError, errorTimeout, expiredSession } from "../../Utilities/General/StatusHandler";

const GroupService = {

    getGroups: async () => {
        try {
            const { data } = await axios.get(
                Urls.urlPayGroup + '?ordering=-timestamp',
                { headers: { Authorization: getToken() } }
            )
            return data
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('400')) return error()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    },

    changeGroupToUsers: async ({ codes, group }) => {
        try {
            const { data } = await axios.post(
                Urls.urlPayGroupChangeGroupToUsers,
                { codes, group },
                { headers: { Authorization: getToken() } }
            )
            return data
        } catch (err) {
            if (err.message.includes('Network Error')) return networkError()
            if (err.message.includes('500')) return serverError()
            if (err.message.includes('400')) return error()
            if (err.message.includes('504')) return errorTimeout()
            if (err.message.includes('401') && !toast.isActive('expiredSessionToast')) return expiredSession()
        }
    }

}

export default GroupService
